module.exports = __webpack_public_path__ + "img/arrow-down-white.80d67afb.svg";